var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { $api } from 'shared/api/api';
import Newbie from 'shared/assets/img/common/newbie.png';
import Specialist from 'shared/assets/img/common/specialist.png';
import Guru from 'shared/assets/img/common/guru.png';
import { fetchUserAchievements } from './fetchUserAchievements';
export var computeUserAchievement = createAsyncThunk('user/computeUserAchievement', function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var dispatch, rejectWithValue, userAchives, completedCoursesRes, courseCount, result, newbie, specialist, guru, e_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                dispatch = thunkAPI.dispatch, rejectWithValue = thunkAPI.rejectWithValue;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 4, , 5]);
                return [4 /*yield*/, dispatch(fetchUserAchievements()).unwrap()];
            case 2:
                userAchives = _c.sent();
                return [4 /*yield*/, $api.post('/ext-course/frontend/training/learning/get-user-completed-courses')];
            case 3:
                completedCoursesRes = _c.sent();
                courseCount = (_b = (_a = completedCoursesRes === null || completedCoursesRes === void 0 ? void 0 : completedCoursesRes.data) === null || _a === void 0 ? void 0 : _a.completed_courses_cnt) !== null && _b !== void 0 ? _b : 0;
                result = __spreadArray([], userAchives.achievements, true);
                newbie = {
                    id: result.length,
                    name: 'Новичок',
                    image: Newbie,
                    date: '',
                };
                specialist = {
                    id: result.length + 1,
                    name: 'Специалист',
                    image: Specialist,
                    date: '',
                };
                guru = {
                    id: result.length + 2,
                    name: 'Гуру',
                    image: Guru,
                    date: '',
                };
                if (courseCount >= 20 && courseCount <= 30) {
                    result.push(newbie);
                    result.push(specialist);
                    result.push(guru);
                }
                else if (courseCount >= 10 && courseCount < 20) {
                    result.push(newbie);
                    result.push(specialist);
                }
                else if (courseCount < 10) {
                    result.push(newbie);
                }
                return [2 /*return*/, result];
            case 4:
                e_1 = _c.sent();
                console.log(e_1);
                return [2 /*return*/, rejectWithValue('error')];
            case 5: return [2 /*return*/];
        }
    });
}); });
